import PatientsOverview from './PatientsOverview';

export default PatientsOverview;
